import React from 'react';
import { usePackery, withPackeryLoading, useEmitterListener } from '@ace/react-utilities';
import { CARD_CENTER_EVENTS } from 'context/CardCenterContext';
import { COMPONENT_TOGGLE_EVENTS } from 'context/ComponentToggleContext';

export const packeryDefaults = {
    options: {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
        initLayout: true
    },
    sizer: <div className={'grid-sizer'}/>
}

function PackeryHandler(props) {
    const { packeryEleRef, refreshLayout } = usePackery(props);

    useEmitterListener(props.componentName, COMPONENT_TOGGLE_EVENTS.ON_TOGGLE, refreshLayout);
    useEmitterListener(props.componentName, COMPONENT_TOGGLE_EVENTS.ON_TOGGLE_ALL, refreshLayout);
    useEmitterListener(props.componentName, COMPONENT_TOGGLE_EVENTS.ON_REFRESH_CARD_LAYOUT, refreshLayout);

    return (
        <div className={props.className} ref={packeryEleRef}>
            {props.sizer ? props.sizer : false}
            {props.children}
        </div>
    );
}

export default withPackeryLoading(PackeryHandler);